import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-brown text-white py-16 md:py-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="font-serif text-3xl tracking-tight">
              Turkan <span className="text-brand-accent italic">Rustamova</span>
            </Link>
            <p className="mt-4 text-brand-secondary/80 text-sm leading-relaxed max-w-md">
              Əl işi sənətkarlığının ən yaxşı nümunələri. Hər bir əsər sevgi və ustalıqla yaradılır.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-brand-accent font-medium mb-6">Naviqasiya</h4>
            <nav className="flex flex-col space-y-3">
              <Link to="/bags" className="text-sm text-white/70 hover:text-brand-accent transition-colors">
                Çantalar
              </Link>
              <Link to="/products" className="text-sm text-white/70 hover:text-brand-accent transition-colors">
                Məhsullar
              </Link>
              <Link to="/about" className="text-sm text-white/70 hover:text-brand-accent transition-colors">
                Haqqımızda
              </Link>
              <Link to="/contact" className="text-sm text-white/70 hover:text-brand-accent transition-colors">
                Əlaqə
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-brand-accent font-medium mb-6">Əlaqə</h4>
            <div className="space-y-3">
              <a href="tel:+994501234567" className="flex items-center gap-3 text-sm text-white/70 hover:text-brand-accent transition-colors">
                <Phone className="w-4 h-4" />
                +994 50 123 45 67
              </a>
              <a href="mailto:info@turkanrustamova.com" className="flex items-center gap-3 text-sm text-white/70 hover:text-brand-accent transition-colors">
                <Mail className="w-4 h-4" />
                info@turkanrustamova.com
              </a>
              <p className="flex items-center gap-3 text-sm text-white/70">
                <MapPin className="w-4 h-4" />
                Bakı, Azərbaycan
              </p>
            </div>
            
            {/* Social Links */}
            <div className="flex gap-3 mt-6">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-primary transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-primary transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-xs text-white/50">
          <p>&copy; {currentYear} Turkan Rustamova. Bütün hüquqlar qorunur.</p>
          <p className="mt-4 md:mt-0">Azərbaycanda sevgi ilə hazırlanıb</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
